<template>
	<article class="post">
		<slot></slot>
	</article>
</template>

<script>
export default{
	name: 'Post'
}
</script>


// WEBPACK FOOTER //
// src/assets/vue/components/Post/Post.vue